/*
 * Membership signup controller (AAC membership rebuild, issue #84).
 * Native Shopify Subscriptions, one page: primary member + inline additional-member repeater + live total,
 * submitted as a multi-line /cart/add (each line carries its own selling_plan + member name property).
 * No framework; self-running + idempotent.
 */
(function () {
  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function init(root) {
    if (!root || root.__skMsBound) return;
    root.__skMsBound = true;

    var cfgEl = root.querySelector('[data-sk-ms-config]');
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var addonTypes = cfg.addonTypes || [];
    var rowsEl = root.querySelector('[data-sk-ms-rows]');
    var addBtnsEl = root.querySelector('[data-sk-ms-add-btns]');
    var totalEl = root.querySelector('[data-sk-ms-total]');
    var primaryEl = root.querySelector('[data-sk-ms-primary]');
    var submitEl = root.querySelector('[data-sk-ms-submit]');
    var errorEl = root.querySelector('[data-sk-ms-error]');

    var rows = []; // { type, name }

    function recalc() {
      var cents = cfg.basePrice;
      rows.forEach(function (r) { cents += r.type.price; });
      if (totalEl) totalEl.innerHTML = money(cents) + '<span class="sk-ms__total-unit"> / month</span>';
    }

    function renderRows() {
      if (!rowsEl) return;
      rowsEl.innerHTML = '';
      rows.forEach(function (r, i) {
        var row = document.createElement('div');
        row.className = 'sk-ms__row';

        // Header line: role label + monthly price + remove button.
        var head = document.createElement('div');
        head.className = 'sk-ms__row-head';

        var inputId = 'sk-ms-addon-' + i;

        var label = document.createElement('label');
        label.className = 'sk-ms__row-label';
        label.setAttribute('for', inputId);
        label.textContent = r.type.label;

        var price = document.createElement('span');
        price.className = 'sk-ms__row-price';
        price.textContent = '+' + r.type.priceText + '/mo';

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'sk-ms__row-remove';
        remove.setAttribute('aria-label', 'Remove ' + r.type.label);
        remove.innerHTML = '&times;';
        remove.addEventListener('click', function () { rows.splice(i, 1); renderRows(); recalc(); });

        head.appendChild(label);
        head.appendChild(price);
        head.appendChild(remove);

        // Full-width name input below the header.
        var input = document.createElement('input');
        input.type = 'text';
        input.id = inputId;
        input.className = 'sk-ms__input sk-ms__row-input';
        input.placeholder = 'Full name';
        input.autocomplete = 'name';
        input.value = r.name || '';
        input.addEventListener('input', function () { r.name = input.value; });

        row.appendChild(head);
        row.appendChild(input);
        rowsEl.appendChild(row);
      });
      recalc();
    }

    // One "Add …" button per add-on type.
    if (addBtnsEl) {
      addonTypes.forEach(function (type) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sk-ms__add-btn';
        b.textContent = '+ Add ' + type.label;
        b.addEventListener('click', function () { rows.push({ type: type, name: '' }); renderRows(); });
        addBtnsEl.appendChild(b);
      });
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = !msg;
    }

    function submit() {
      showError('');
      var primary = (primaryEl && primaryEl.value || '').trim();
      if (!primary) {
        showError('Please enter who this membership is for.');
        primaryEl && primaryEl.focus();
        return;
      }
      for (var i = 0; i < rows.length; i++) {
        if (!(rows[i].name || '').trim()) {
          showError('Please enter a name for each additional member (or remove the empty one).');
          return;
        }
      }

      var items = [{
        id: cfg.mainVariantId,
        quantity: 1,
        selling_plan: cfg.mainPlanId,
        properties: { 'Member name': primary }
      }];
      rows.forEach(function (r) {
        items.push({
          id: r.type.variantId,
          quantity: 1,
          selling_plan: r.type.planId,
          properties: { 'Member name': r.name.trim(), 'Membership': cfg.productTitle }
        });
      });

      submitEl.disabled = true;
      submitEl.textContent = 'Adding…';
      fetch(root.getAttribute('data-cart-add'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json().then(function (b) { return { ok: res.ok, body: b }; }); })
        .then(function (r) {
          if (!r.ok) {
            showError((r.body && r.body.description) || 'Could not add to cart. Please try again.');
            submitEl.disabled = false;
            submitEl.textContent = 'Join Now';
            return;
          }
          window.location.href = root.getAttribute('data-cart-url') || '/cart';
        })
        .catch(function () {
          showError('Network error. Please try again.');
          submitEl.disabled = false;
          submitEl.textContent = 'Join Now';
        });
    }

    if (submitEl) submitEl.addEventListener('click', submit);
    recalc();
  }

  function boot() {
    document.querySelectorAll('[data-sk-ms]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
